import { Component } from 'react';
import { EnvService, CacheService, IStorageLocal, SearchOperation, PackageService } from 'namirasoft-core';
import { NamirasoftAPIProductServer, ProductFullRow } from 'namirasoft-api-product';
import { NSBoxSearch, NSDialog, NSDialogProps, NSLoading } from 'namirasoft-site-react';
import { NSARouterMakerProps } from '../NSARouterMakerProps';
import Styles from './NSAProductListDialog.module.css';


export interface NSAProductListDialogProps extends NSARouterMakerProps, NSDialogProps
{
}

interface NSAProductListState
{
	products: ProductFullRow[] | null;
	search: string;
}

export class NSAProductListDialog extends Component<NSAProductListDialogProps, NSAProductListState>
{
	private cache: CacheService<{
		rows: ProductFullRow[];
		count: number;
	}>;

	constructor(props: NSAProductListDialogProps)
	{
		super(props);
		this.state = { products: null, search: "" };

		this.cache = new CacheService<{
			rows: ProductFullRow[];
			count: number;
		}>("ns-products", new IStorageLocal(), 24 * 60, async () => "1.0.0", async () =>
		{
			let REACT_APP_BASE_URL_API_PRODUCT = new EnvService("REACT_APP_BASE_URL_API_PRODUCT", true).getString();
			let server = new NamirasoftAPIProductServer(REACT_APP_BASE_URL_API_PRODUCT, props.notifier.onError);
			let ans = await server.filter.ListProducts("Namirasoft Console", "Header", null, null, null, []);
			if (PackageService.MainJson)
			{
				let CurrentProjectName = PackageService.MainJson?.title.replace("Console", "").trim();
				ans.rows = ans.rows.filter(r => r.name !== CurrentProjectName);
				ans.count = ans.rows.length;
			}
			return ans;
		});
	}

	override componentDidMount(): void
	{
		this.cache.get().then((res) =>
		{
			this.setState({ products: res.rows });
		}).catch(() => { });
	}

	override render()
	{
		let content = null;
		if (this.state.products == null)
			content = <NSLoading />;
		else
		{
			let products = SearchOperation.filter(this.state.products, p => p.name, this.state.search);
			let getName = (name: string) =>
			{
				return name.replace("Namirasoft ", "").trim();
			};
			let content_products = (
				<div className={Styles.nsa_product_list_container}>
					{
						products.map((product) => (
							<div key={product.id} className={Styles.nsa_product_list}>
								<a href={product.link || ""} target='_blank' rel="noreferrer" >
									<figure className={Styles.nsa_product_logo} key={product.id}>
										<img src={`${product.logo}`} alt={product.name} width={64} height={64} />
										<figcaption>{`${getName(product.name)}`}</figcaption>
									</figure>
								</a>
							</div>
						))
					}
				</div>
			);
			content = (
				<>
					<NSBoxSearch
						title=""
						required={false}
						style={{ width: "302px" }}
						placeholder='Search your Product'
						onChanged={(e) =>
						{
							this.setState({ search: e.getValue() ?? "" });
						}}
					/>
					{content_products}
				</>
			);
		}
		return (
			<NSDialog {...this.props}>
				{content}
			</NSDialog>
		);
	}
}